/*
 * @Author: kian
 * @Date: 2021-11-11 08:56:44
 * @LastEditors: kian
 * @LastEditTime: 2021-11-24 17:38:53
 * @Description:
 */
import Vue from 'vue';
export function rafThrottle(fn) {
  let locked = false;
  return function (...args) {
    if (locked) return;
    locked = true;
    window.requestAnimationFrame((_) => {
      fn.apply(this, args);
      locked = false;
    });
  };
}

export const isFirefox = function () {
  return (
    !Vue.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i)
  );
};

/**
 * @description 获取路由传参
 * @param { string } url 路由参数
 */
export const getUrlQuery = (url) => {
  const queryStr = url.split('?')[1];
  if (queryStr) {
    const query = {};
    const queryArr = queryStr.split('&');
    if (queryArr.length > 0) {
      queryArr.forEach((item) => {
        const prop = item.split('=');
        if (prop.length > 1) {
          query[prop[0]] = prop[1];
        }
      });
    }
    return query;
  }
  return null;
};

/**
 * @description 对数字做千位分隔
 * @param { number } num 处理数字
 * @returns { string } 格式化后的数字
 */
export const numFormat = (num) => {
  const res = num.toString().replace(/\d+/, (n) => {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => {
      return `${$1},`;
    });
  });
  return res;
};

/**
 * @description 股票格式化
 * @param { string } stock 股票代码
 */
export const stockInit = (stock) => {
  if (stock.length < 3) return null;
  return {
    market: stock.slice(0, 2).toLowerCase(),
    code: stock.slice(2),
  };
};

/**
 * @description 跳转链接
 * @param { String } url 跳转路径
 * @param { String } type 跳转类型 href: 直跳 _blank: 新开页
 */
export const linkPage = (url, type = '_blank') => {
  const uuu = new URL(url, location.origin);
  if (uuu.origin.includes('www.gelonghui.com')) {
    openLink(uuu.href, type);
  } else if (uuu.origin.includes('m.gelonghui.com')) {
    const routes = ['/mobile', '/thanksgiving'];
    let isJumpToWeb = true;
    routes.forEach((item) => {
      if (uuu.href.includes(item)) {
        isJumpToWeb = false;
      }
    });
    if (isJumpToWeb) {
      openLink(uuu.href.replace('m.gelonghui.com', 'www.gelonghui.com'), type);
    } else {
      openLink(uuu.href, type);
    }
  } else {
    openLink(url, type);
  }
};

/**
 * @description 跳转链接方式
 * @param { String } url 跳转路径
 * @param { String } type 跳转类型 href: 直跳 _blank: 新开页
 */
export const openLink = (url, type = '_blank') => {
  if (type === '_blank') {
    window.open(url);
  } else if (type === 'href') {
    location.href = url;
  }
};

/**
 * @description 路由去除域名
 * @param { String } url 原路由
 * @returns { String } 格式化路由
 */
export const formartRoute = (url) => {
  return url.replace(/^http[s]{0,1}:\/\/[^/]+/, '');
};

export const colorRgb = function (color, opacity = 1) {
  let sColor = color.toLowerCase();
  // 十六进制颜色值的正则表达式
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#';
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    // 处理六位的颜色值
    const sColorChange = [];
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)));
    }
    return 'rgba(' + sColorChange.join(',') + ',' + opacity + ')';
  }
  return sColor;
};
